import app from '@/app';

/* @ngInject */
function Structure($resource) {
	return $resource(
		'api/structures/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Structure', Structure);
